/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CasePredictionRequest,
  DownloadDraftRequest,
  DraftRequest,
  DraftResponse,
  HTTPValidationError,
  LegalResearchRequest,
  LegalResearchResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Dashboard<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description Serve the contract analysis interface
   *
   * @tags contracts
   * @name GetContractAnalysisInterfaceDashboardContractReviewGet
   * @summary Get Contract Analysis Interface
   * @request GET:/dashboard/contract-review
   */
  getContractAnalysisInterfaceDashboardContractReviewGet = (
    params: RequestParams = {}
  ) =>
    this.request<string, any>({
      path: `/dashboard/contract-review`,
      method: "GET",
      ...params,
    });
  /**
   * @description Serves the legal research HTML page
   *
   * @tags research
   * @name GetLegalResearchPageDashboardLegalResearchGet
   * @summary Get Legal Research Page
   * @request GET:/dashboard/legal-research/
   */
  getLegalResearchPageDashboardLegalResearchGet = (
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/dashboard/legal-research/`,
      method: "GET",
      ...params,
    });
  /**
   * @description Realiza investigación jurídica especializada según el ordenamiento jurídico colombiano, incluyendo análisis de jurisprudencia, doctrina y normativa aplicable.
   *
   * @tags research
   * @name ResearchEndpointDashboardLegalResearchInvestigatePost
   * @summary Investigación Jurídica Especializada
   * @request POST:/dashboard/legal-research/investigate
   */
  researchEndpointDashboardLegalResearchInvestigatePost = (
    data: LegalResearchRequest,
    params: RequestParams = {}
  ) =>
    this.request<LegalResearchResponse, HTTPValidationError>({
      path: `/dashboard/legal-research/investigate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get available legal research areas
   *
   * @tags research
   * @name GetResearchAreasDashboardLegalResearchAreasGet
   * @summary Get Research Areas
   * @request GET:/dashboard/legal-research/areas
   */
  getResearchAreasDashboardLegalResearchAreasGet = (
    params: RequestParams = {}
  ) =>
    this.request<any, any>({
      path: `/dashboard/legal-research/areas`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get available document types
   *
   * @tags research
   * @name GetAvailableDocumentTypesDashboardLegalResearchDocumentTypesGet
   * @summary Get Available Document Types
   * @request GET:/dashboard/legal-research/document-types
   */
  getAvailableDocumentTypesDashboardLegalResearchDocumentTypesGet = (
    params: RequestParams = {}
  ) =>
    this.request<any, any>({
      path: `/dashboard/legal-research/document-types`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Generate a document draft based on research results
   *
   * @tags research
   * @name GenerateDraftDashboardLegalResearchGenerateDraftPost
   * @summary Generate Draft
   * @request POST:/dashboard/legal-research/generate-draft
   */
  generateDraftDashboardLegalResearchGenerateDraftPost = (
    data: DraftRequest,
    params: RequestParams = {}
  ) =>
    this.request<DraftResponse, HTTPValidationError>({
      path: `/dashboard/legal-research/generate-draft`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate and download document in specified format
   *
   * @tags research
   * @name DownloadDraftDashboardLegalResearchDownloadDraftPost
   * @summary Download Draft
   * @request POST:/dashboard/legal-research/download-draft
   */
  downloadDraftDashboardLegalResearchDownloadDraftPost = (
    data: DownloadDraftRequest,
    params: RequestParams = {}
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/dashboard/legal-research/download-draft`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Sirve la interfaz web para redacción de documentos
   *
   * @tags documents
   * @name GetDocumentDraftingInterfaceDashboardDocumentDraftingGet
   * @summary Interface de Redacción de Documentos
   * @request GET:/dashboard/document-drafting/
   */
  getDocumentDraftingInterfaceDashboardDocumentDraftingGet = (
    params: RequestParams = {}
  ) =>
    this.request<string, any>({
      path: `/dashboard/document-drafting/`,
      method: "GET",
      ...params,
    });
  /**
   * @description Serves the case prediction HTML page
   *
   * @tags case_prediction
   * @name GetCasePredictionPageDashboardCasePredictionGet
   * @summary Get Case Prediction Page
   * @request GET:/dashboard/case-prediction/
   */
  getCasePredictionPageDashboardCasePredictionGet = (
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/dashboard/case-prediction/`,
      method: "GET",
      ...params,
    });
  /**
   * @description Analyze case endpoint
   *
   * @tags case_prediction
   * @name AnalyzeCaseDashboardCasePredictionAnalyzePost
   * @summary Analyze Case
   * @request POST:/dashboard/case-prediction/analyze
   */
  analyzeCaseDashboardCasePredictionAnalyzePost = (
    data: CasePredictionRequest,
    params: RequestParams = {}
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/dashboard/case-prediction/analyze`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Obtiene los tipos de procesos disponibles para análisis
   *
   * @tags case_prediction
   * @name GetCaseTypesDashboardCasePredictionCaseTypesGet
   * @summary Tipos de Procesos
   * @request GET:/dashboard/case-prediction/case-types
   */
  getCaseTypesDashboardCasePredictionCaseTypesGet = (
    params: RequestParams = {}
  ) =>
    this.request<Record<string, string[]>, any>({
      path: `/dashboard/case-prediction/case-types`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Analyze laws endpoint
   *
   * @tags case_prediction
   * @name AnalyzeLawsDashboardCasePredictionAnalyzeLawsPost
   * @summary Analyze Laws
   * @request POST:/dashboard/case-prediction/analyze-laws
   */
  analyzeLawsDashboardCasePredictionAnalyzeLawsPost = (
    data: CasePredictionRequest,
    params: RequestParams = {}
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/dashboard/case-prediction/analyze-laws`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Analyze similar cases endpoint
   *
   * @tags case_prediction
   * @name AnalyzeSimilarCasesDashboardCasePredictionAnalyzeSimilarCasesPost
   * @summary Analyze Similar Cases
   * @request POST:/dashboard/case-prediction/analyze-similar-cases
   */
  analyzeSimilarCasesDashboardCasePredictionAnalyzeSimilarCasesPost = (
    data: CasePredictionRequest,
    params: RequestParams = {}
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/dashboard/case-prediction/analyze-similar-cases`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Debug endpoint to check incoming request data
   *
   * @tags case_prediction
   * @name DebugRequestDashboardCasePredictionDebugPost
   * @summary Debug Request
   * @request POST:/dashboard/case-prediction/debug
   */
  debugRequestDashboardCasePredictionDebugPost = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/dashboard/case-prediction/debug`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Render the dashboard page
   *
   * @tags dashboard
   * @name GetDashboardPageDashboardGet
   * @summary Get Dashboard Page
   * @request GET:/dashboard/
   */
  getDashboardPageDashboardGet = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/dashboard/`,
      method: "GET",
      ...params,
    });
  /**
   * @description Get real-time dashboard statistics
   *
   * @tags dashboard
   * @name GetDashboardStatsDashboardApiDashboardStatsGet
   * @summary Get Dashboard Stats
   * @request GET:/dashboard/api/dashboard-stats
   */
  getDashboardStatsDashboardApiDashboardStatsGet = (
    params: RequestParams = {}
  ) =>
    this.request<any, any>({
      path: `/dashboard/api/dashboard-stats`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get recent user activity
   *
   * @tags dashboard
   * @name GetRecentActivityDashboardApiRecentActivityGet
   * @summary Get Recent Activity
   * @request GET:/dashboard/api/recent-activity
   */
  getRecentActivityDashboardApiRecentActivityGet = (
    params: RequestParams = {}
  ) =>
    this.request<any, any>({
      path: `/dashboard/api/recent-activity`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get service usage statistics
   *
   * @tags dashboard
   * @name GetServiceUsageDashboardApiDashboardServiceUsageGet
   * @summary Get Service Usage
   * @request GET:/dashboard/api/dashboard/service-usage
   */
  getServiceUsageDashboardApiDashboardServiceUsageGet = (
    params: RequestParams = {}
  ) =>
    this.request<any, any>({
      path: `/dashboard/api/dashboard/service-usage`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get user-related metrics
   *
   * @tags dashboard
   * @name GetUserMetricsDashboardApiDashboardUserMetricsGet
   * @summary Get User Metrics
   * @request GET:/dashboard/api/dashboard/user-metrics
   */
  getUserMetricsDashboardApiDashboardUserMetricsGet = (
    params: RequestParams = {}
  ) =>
    this.request<any, any>({
      path: `/dashboard/api/dashboard/user-metrics`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get system health metrics
   *
   * @tags dashboard
   * @name GetSystemHealthDashboardApiDashboardSystemHealthGet
   * @summary Get System Health
   * @request GET:/dashboard/api/dashboard/system-health
   */
  getSystemHealthDashboardApiDashboardSystemHealthGet = (
    params: RequestParams = {}
  ) =>
    this.request<any, any>({
      path: `/dashboard/api/dashboard/system-health`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Render the profile page
   *
   * @tags dashboard
   * @name GetProfilePageDashboardProfileGet
   * @summary Get Profile Page
   * @request GET:/dashboard/profile
   */
  getProfilePageDashboardProfileGet = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/dashboard/profile`,
      method: "GET",
      ...params,
    });
  /**
   * @description Render the settings page
   *
   * @tags dashboard
   * @name GetSettingsPageDashboardSettingsGet
   * @summary Get Settings Page
   * @request GET:/dashboard/settings
   */
  getSettingsPageDashboardSettingsGet = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/dashboard/settings`,
      method: "GET",
      ...params,
    });
}
